module.exports = __webpack_public_path__ + "a74ce5cdb66ea82f2091580baae83ac1.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Messages/messagesBg.png
// module id = 885
// module chunks = 0